export function describeSecurePackageError(err) {
  const status = err?.response?.status;
  const headers = err?.response?.headers || {};
  const data = err?.response?.data || {};
  const hasResponse = Boolean(err?.response);
  const hasRequest = Boolean(err?.request);
  const errorCode = err?.code || null;
  const errorMessage = String(err?.message || '');
  const correlationId =
    headers['x-correlation-id'] ||
    headers['X-Correlation-Id'] ||
    data?.correlationId ||
    data?.apiError?.correlationId ||
    null;

  const errorClassByStatus = {
    401: 'SESSION_EXPIRED',
    403: 'STEP_UP_REQUIRED',
    404: 'LINK_UNAVAILABLE',
    429: 'RATE_LIMITED',
    502: 'EMAIL_SERVICE_UNAVAILABLE',
  };

  const errorClass = errorClassByStatus[status] || 'SECURE_PACKAGE_ERROR';

  if (!hasResponse) {
    if (hasRequest || errorCode === 'ERR_NETWORK' || /network error/i.test(errorMessage)) {
      return {
        title: 'Download service unavailable',
        message:
          'We could not reach the download service. Please check your connection and try again.',
        retryable: true,
        correlationId,
        errorClass: 'NETWORK_ERROR',
      };
    }

    return {
      title: 'Could not start download',
      message:
        'Your browser could not start the download. Refresh the page or try another browser.',
      retryable: true,
      correlationId,
      errorClass: 'DOWNLOAD_START_FAILED',
    };
  }

  switch (status) {
    case 401:
      return {
        title: 'Sign in required',
        message: 'Your session has expired. Please sign in again.',
        retryable: true,
        correlationId,
        errorClass,
      };
    case 403:
      return {
        title: 'Verification required',
        message:
          'You need to verify your identity with a one-time code before opening this item, or your access window has expired.',
        retryable: true,
        correlationId,
        errorClass,
      };
    case 404:
      return {
        title: 'Link unavailable',
        message:
          'This secure link is no longer available. It may have expired or already been used. Ask the sender to resend it.',
        retryable: false,
        correlationId,
        errorClass,
      };
    case 429:
      return {
        title: 'Too many attempts',
        message: 'Please wait a minute and try again.',
        retryable: true,
        correlationId,
        errorClass,
      };
    case 502:
      return {
        title: 'Email service unavailable',
        message:
          'The email service is temporarily unavailable. Please try again shortly.',
        retryable: true,
        correlationId,
        errorClass,
      };
    default:
      return {
        title: 'Something went wrong',
        message:
          'Please try again. If the problem continues, contact IT support with the reference below.',
        retryable: true,
        correlationId,
        errorClass,
      };
  }
}
